import { z } from 'zod';

export const intercomEventSchema = z.discriminatedUnion('event', [
  z.object({
    event: z.literal('clear-all-device-session'),
  }),
  z.object({
    event: z.literal('update-enter-as-submit'),
    data: z.object({
      value: z.boolean(),
    }),
  }),
]);

export type IntercomEvent = z.infer<typeof intercomEventSchema>;
